// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3eEh_cvwCUDPos {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: #42526E;\n  padding: 0;\n  text-decoration: none;\n}\n._3eEh_cvwCUDPos:active,\n._3eEh_cvwCUDPos:hover {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n  color: #172B4D;\n  cursor: pointer;\n  outline: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": "_3eEh_cvwCUDPos"
};
export default ___CSS_LOADER_EXPORT___;
